import { render, staticRenderFns } from "./CategoryCreateView.vue?vue&type=template&id=67af4674&scoped=true"
import script from "./CategoryCreateView.vue?vue&type=script&lang=js"
export * from "./CategoryCreateView.vue?vue&type=script&lang=js"
import style0 from "./CategoryCreateView.vue?vue&type=style&index=0&id=67af4674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af4674",
  null
  
)

export default component.exports